webpackJsonp([13],{

/***/ 172:
/***/ (function(module, exports) {

module.exports = {"jugar":"Play","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.7b7aac343a34dd6ffcc6.js